<template>
    <v-app>
        <!-- dashboard -->
        <navigation v-if="this.$store.state.showNavbar" />

        <!-- pages -->
        <v-content>
            <router-view></router-view>
        </v-content>
        <v-snackbar
            class="snackbar"
            v-model="showSnackBar"
            @click="showSnackBar = false"
            :timeout="4000"
            bottom
            center
            color="red darken-2"
        >
            {{ snackbarText }}
        </v-snackbar>
    </v-app>
</template>

<script>
import navigation from '@/components/navigation';
import dispatcherNav from '@/components/dispatcherNav';
import { bus } from '@/main';

export default {
    name: 'App',

    components: {
        navigation,
        dispatcherNav,
    },

    data() {
        return {
            // hide navbar
            showNavbar: false,
            showSnackBar: false,
            snackbarText: '',
        };
    },

    created() {
        this.$store.dispatch('common/tryAutoLogin');
        // this.$store.dispatch("getUser");
    },

    mounted() {
        bus.$on('onError', (err) => {
            this.showErrorHandler(err);
        });
    },

    methods: {
        showErrorHandler(err) {
            this.snackbarText = err;
            this.showSnackBar = true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';

.snackbar {
    cursor: pointer;
}
</style>
